import React from "react";
import AuthContainer from "../../containers/AuthContainer";
import QuestionIcon from "../../assets/icons/question.png";
import {Content} from "../../styles/GlobalStyles";
import {TitleAuth, ContentAuth, CardAuth, TextAuth} from "../auth/components/AuthStyles";
import styled from "styled-components";
import Color from "../../assets/Colors";
import parse from "html-react-parser";
import ArrowIcon from "../../assets/icons/to_right.png";

//src\assets\icons\to_right.png

export default function FrecuentQuestions() {
   return (
      <AuthContainer classname="invert">
         <Content>
            <MarginTop />
            <ContentAuth justify="flex-start" direction="column">
               <QuestionContainer>
                  <Question />
                  <Answer>
                     <TitleAuth>
                        <img style={{width: "25px", marginRight: "15px"}} src={QuestionIcon} alt="Icon" />
                        Preguntas frecuentes{" "}
                     </TitleAuth>

                     <TextAnswer>
                        ¿Tienes alguna duda? Te invitamos a leer las preguntas frecuentes o{" "}
                        <a href="/contacto" className="textLink">
                           ponte en contacto con nosotros.
                        </a>
                     </TextAnswer>
                  </Answer>
               </QuestionContainer>
               {QuestionsList.map((item) => {
                  return (
                     <QuestionContainer key={item.id}>
                        <Question>
                           <TitleCuestion>{item.question}</TitleCuestion>
                        </Question>
                        <Answer>
                           <TextAnswer>{parse(item.answer)}</TextAnswer>
                        </Answer>
                     </QuestionContainer>
                  );
               })}
            </ContentAuth>
         </Content>
      </AuthContainer>
   );
}

const MarginTop = styled.div`
   width: 100%;
   padding-bottom: 5em;
   @media screen and (max-width: 500px) {
      padding-bottom: 0;
   }
`;

const QuestionContainer = styled.div`
   width: 100%;
   display: flex;
   align-items: flex-start;
   padding: 1.5em 0;
   @media screen and (max-width: 500px) {
      flex-direction: column;
      padding: 4em 1.5em 0;
   }
`;
const Question = styled.div`
   width: 37%;
   padding-right: 3em;
   font-size: 1.2em;
   @media screen and (max-width: 1600px) {
      padding-right: 2.5em;
   }
   @media screen and (max-width: 500px) {
      width: 100%;
   }
`;
const Answer = styled.div`
   width: 54%;

   @media screen and (max-width: 500px) {
      width: 100%;
      margin-top: 0.5em;
   }
`;
const TextAnswer = styled.p`
   font-size: 1.4em;
   line-height: 1.5em;
   font-weight: 200;
   color: ${Color.textColor};

   & .actionLink {
      color: ${Color.secondary};
      font-weight: 400;
      position: relative;

      &:after{
         content: "";
         background-image: url(${ArrowIcon});
         position: absolute;
         width: 1em;
         height: 1em;
         top: 15%;
         right: -1.5em;
         background-size: contain;
      }
   }

   & .textLink {
      position: relative;
      display: inline-block;
      color: ${Color.textColor};

      &:before {
         content: "";
         position: absolute;
         bottom: -1px;
         width: 100%;
         border-bottom: 1px dotted grey;
         height: 1px:
      } 
   }

   @media screen and (max-width: 1600px) {
      font-size: 1em;
      line-height: 1.3em;

      & .textLink {
         
         &:before {
           bottom: 0;
         } 
      }
   }
   @media screen and (max-width: 500px){
      font-size: 0.9em;
      line-height: 1.4em;
      font-weight: 200;
   }
`;

const TitleCuestion = styled(TextAnswer)`
   color: ${Color.primary};
   font-weight: 400;
`;

const QuestionsList = [
   {
      id: "1",
      question: "¿Donde está Domecq Academy?",
      answer: `<span>
            Domecq Academy se encuentra ubicado dentro del Corporativo Casa Pedro Domecq en el corazón de Polanco. <br/> <br />
            Avenida Presidente Masaryk 275, Col. Polanco, 11550, CDMX (entrada por Temístocles).
            <br/> <br />
            <a class="actionLink" href="/contacto">Abrir mapa</a>
         </span>`,
   },
   {
      id: "2",
      question: "¿Tienen algún costo los cursos?",
      answer: `<span>Estos cursos son solo por invitación, y no tienen ningún costo. En Domecq Academy estamos
      comprometidos con la educación y la promoción de la cultura en vinos y destilados. Creemos que la
      capacitación crea oportunidades y nos hace crecer a todos como industria. Domecq Academy es el
      lugar de la experiencia, la pasión y el conocimiento.</span>`,
   },
   {
      id: "3",
      question: "¿Tengo que llevar algo a las capacitaciones?",
      answer: `<span>Tu asistencia y tu pasión por seguir aprendiendo es lo más importante, todo lo demás se te
      proporcionará durante la capacitación.</span>`,
   },
   {
      id: "4",
      question: "¿Cuáles son los requisitos para obtener mi certificado?",
      answer: `<span>Para ser acreedor a tu certificado deberás de cumplir con el 80% de asistencia, puntualidad y
      acreditar la evaluación final.</span>`,
   },
   {
      id: "5",
      question: "¿Los cursos son seriados?",
      answer: `<span>No, pero cada curso te brindará una experiencia y conocimiento diferente por lo que es importante
      que estés ubicado en el que te sientas cómodo de acuerdo a tu grado de expertise.</span>`,
   },
   {
      id: "6",
      question: "¿Puedo invitar a más personas?",
      answer: `<span>La invitación es personal e intransferible.</span>`,
   },
   {
      id: "7",
      question: "¿Cómo me mantengo al día con la oferta académica?",
      answer: `<span><a href="#footer" class="textLink" />Suscríbete a nuestro newsletter </a>, así podrás recibir noticias e información de valor sobre el mundo de
      Domecq Academy. También puedes seguirnos en Facebook e Instagram o visitar regularmente
      nuestro website.</span>`,
   },
   {
      id: "8",
      question: "¿Cómo aporta Domecq Academy a mi desarrollo y profesionalización en la industria?",
      answer: `<span>Domecq Academy te proporcionará una excelente formación con facilitadores de renombre y de gran
      experiencia. Con nosotros obtendrás toda la información y formación que requieres para potenciar tu
      talento y actualizar tus conocimientos.</span>`,
   },
];
